// extracted by mini-css-extract-plugin
export default {"input":"_oa-z","button":"apa-z","selected":"bpa-z","unavailable":"cpa-z","image":"dpa-z"};